import * as React from 'react';
import { useBlocker, type ShouldBlockFn } from '@tanstack/react-router';
import { useUnsavedChanges } from '@shigo-ui/ui';

import { DiscardChangesDialog } from './DiscardChangesDialog';
import { isEditorSectionNavigation } from './editorSectionContext';

export function UnsavedChangesNavigationGuard() {
  const { hasUnsavedChanges } = useUnsavedChanges();
  const shouldBlock = React.useCallback<ShouldBlockFn>(
    ({ current, next }) => hasUnsavedChanges && !isEditorSectionNavigation(current, next),
    [hasUnsavedChanges],
  );
  const blocker = useBlocker({
    shouldBlockFn: shouldBlock,
    enableBeforeUnload: () => hasUnsavedChanges,
    withResolver: true,
  });
  const blocked = blocker.status === 'blocked';

  return (
    <DiscardChangesDialog
      open={blocked}
      onStay={() => {
        if (blocker.status === 'blocked') blocker.reset();
      }}
      onDiscard={() => {
        if (blocker.status === 'blocked') blocker.proceed();
      }}
    />
  );
}
